// localStorage-backed "saved coaches" list for the `/coaches/search` directory.
// Mirrors `src/lib/pga-coach/saved-offerings.js` so the two surfaces share the
// same client-only, anonymous favoriting pattern (no auth, no backend write).
// Coach ids are stored as strings; the Algolia `objectID` is the canonical key.

export const PGA_COACH_DIRECTORY_SAVED_COACHES_KEY = 'pga-coach-directory-saved-coaches'

const readIds = () => {
  if (typeof window === 'undefined') return []
  try {
    const raw = window.localStorage.getItem(PGA_COACH_DIRECTORY_SAVED_COACHES_KEY)
    if (!raw) return []
    const parsed = JSON.parse(raw)
    return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : []
  } catch {
    return []
  }
}

const writeIds = (ids) => {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(
    PGA_COACH_DIRECTORY_SAVED_COACHES_KEY,
    JSON.stringify([...new Set(ids)]),
  )
}

export const getSavedCoachIds = () => readIds()

export const isCoachSaved = (coachId) => {
  if (!coachId) return false
  return readIds().includes(String(coachId))
}

export const toggleSavedCoach = (coachId) => {
  if (!coachId) return false
  const id = String(coachId)
  const next = readIds()
  const idx = next.indexOf(id)
  if (idx >= 0) {
    next.splice(idx, 1)
    writeIds(next)
    return false
  }
  next.push(id)
  writeIds(next)
  return true
}
